import { cn } from '../utils';

export default function BlurredBg(
  props: React.PropsWithChildren<{ className?: { bg?: string; container?: string } }>,
) {
  return (
    <>
      <div
        className={cn(
          'absolute top-0 size-full max-w-[600px] bg-[#1A1A1A]/70',
          props.className?.bg,
        )}
      ></div>
      <div
        id='scrolled-wrapper'
        className={cn(
          'absolute top-0 h-full w-full backdrop-blur-lg overflow-x-hidden overflow-y-auto',
          props.className?.container,
        )}
      >
        {props.children}
      </div>
    </>
  );
}
